import { useRef, useState, useEffect } from 'react';

// Renders a self-contained HTML artifact (a Board "embed" post) inside a
// sandboxed iframe (CJ 2026-07-31). sandbox="allow-scripts" WITHOUT
// allow-same-origin means the artifact's own CSS/JS run with full fidelity
// (grid, flex, CSS vars, dark-mode media queries, its theme toggle) but it
// CANNOT reach Monarch's DOM, cookies, or storage — so no sanitizing is needed
// and a hostile paste is contained. We inject a tiny resize reporter so the
// frame grows to fit its content instead of showing an inner scrollbar.

const RESIZE_SNIPPET = `<script>(function(){
  function h(){try{parent.postMessage({__boardEmbed:1,h:Math.max(document.documentElement.scrollHeight,document.body?document.body.scrollHeight:0)},'*');}catch(e){}}
  addEventListener('load',h);addEventListener('resize',h);
  if(window.ResizeObserver){try{new ResizeObserver(h).observe(document.documentElement);}catch(e){}}
  document.fonts&&document.fonts.ready&&document.fonts.ready.then(h);
  setTimeout(h,150);setTimeout(h,600);setTimeout(h,1500);
})();<\/script>`;

const MAX_H = 12000;   // safety ceiling; beyond this the frame scrolls internally

function withResizeReporter(html) {
  const s = String(html || '');
  if (s.includes('</body>')) return s.replace('</body>', RESIZE_SNIPPET + '</body>');
  return s + RESIZE_SNIPPET;
}

export function EmbedFrame({ html, title = 'Embedded content' }) {
  const ref = useRef(null);
  const [height, setHeight] = useState(420);
  useEffect(() => {
    function onMsg(e) {
      if (!ref.current || e.source !== ref.current.contentWindow) return;
      const d = e.data;
      if (d && d.__boardEmbed && typeof d.h === 'number' && d.h > 0) {
        setHeight(Math.min(Math.ceil(d.h) + 4, MAX_H));
      }
    }
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);
  return (
    <iframe
      ref={ref}
      title={title}
      sandbox="allow-scripts"
      srcDoc={withResizeReporter(html)}
      style={{ width: '100%', height, border: '1px solid #e0e0e0', borderRadius: 10, background: '#fff', display: 'block' }}
    />
  );
}
